const styles = theme => ({
  baseRoot: {
    alignItems: 'center',
    backgroundColor: '#00C396',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    borderRadius: '2px',
    color: '#FFFFFF',
    display: 'flex',
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 5
  },
  root: {},
  info: {
    alignItems: 'center',
    display: 'flex',
    flex: 1
  },
  icon: {
    height: 64,
    marginRight: theme.spacing.unit * 5,
    width: 64
  },
  title: {
    color: '#FFFFFF !important',
    marginBottom: theme.spacing.unit
  },
  message: {
    color: 'rgba(255,255,255,0.6)'
  },
  actions: {
    display: 'flex',
    flexDirection: 'column'
  },
  basePrintAction: {
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    margin: 0,
    marginBottom: theme.spacing.unit * 2,
    '&:hover': {
      backgroundColor: '#FFFFFF',
      '& > span': {
        color: '#00b78c'
      }
    }
  },
  printAction: {},
  basePrintActionLabel: {
    color: '#00C396'
  },
  printActionLabel: {},
  sendAction: {
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.06)',
      '& > span': {
        color: '#FFFFFF'
      }
    }
  },
  sendActionLabel: {
    color: '#FFFFFF'
  },
  gridHeight: { height: '90%' },
  shareSection: {}
});

export default styles;
